import { http } from '@/_services/http.service'

export const documentService = {

  getDocuments () {

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document`, options)
            .then(response => response.json())
  },

  download (id) {

    const options = {
      method: 'GET',
      responseType: 'blob',
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document/${id}`, options).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.blob()
    }).catch(error => {
      console.log(error)
      alert('Er is iets fout gegaan, herlaadt de pagina en probeer het opnieuw')
    })
  },

  destroy (id) {
    const options = {
      method: 'DELETE',
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document/${id}`, options).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    }).catch(error => {
      console.log(error)
      alert('Er is iets fout gegaan, herlaadt de pagina en probeer het opnieuw')
    })
  },

  postDocument (id, file, forPartner) {
    const formData = new FormData()
    formData.append('payload', file)
    formData.append('id', id)
    formData.append('partner', forPartner)

    const options = {
      method: 'POST',
      body: formData
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document`, options)
            .then(response => response.json())

  }

}
